import { ScreenEmail } from '../OwnAIMan_Trans_L/screens/Email';
import { FlirtingStyleScreen } from '../OwnAIMan_Trans_L/screens/FlirtingStyle';
import { HisTypeScreen } from '../OwnAIMan_Trans_L/screens/HisType';
import { HisVoiceScreen } from '../OwnAIMan_Trans_L/screens/HisVoice';
import { HobbiesInterestsScreen } from '../OwnAIMan_Trans_L/screens/HobbiesInterests';
import { HowOftenReachOutScreen } from '../OwnAIMan_Trans_L/screens/HowOftenReachOut';
import { ScreenName } from '../OwnAIMan_Trans_L/screens/Name';
import { ScreenPersonality } from '../OwnAIMan_Trans_L/screens/Personality';
import { RoleInRelationshipScreen } from '../OwnAIMan_Trans_L/screens/RoleInRelationship';
import { ShowLoveScreen } from '../OwnAIMan_Trans_L/screens/ShowLove';
import { SummaryScreen } from '../OwnAIMan_Trans_L/screens/SummaryScreen';
import { WelcomeScreen } from '../OwnAIMan_Trans_L/screens/Welcome';

import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  his_type: {
    component: HisTypeScreen,
    images: [],
  },
  his_voice: {
    component: HisVoiceScreen,
    images: [],
  },
  show_love: {
    component: ShowLoveScreen,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  how_often_reach_out: {
    component: HowOftenReachOutScreen,
    images: [],
  },
  flirting_style: {
    component: FlirtingStyleScreen,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  hobbies_interests: {
    component: HobbiesInterestsScreen,
    images: [],
  },
  role_in_relationship: {
    component: RoleInRelationshipScreen,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
  summary: {
    component: SummaryScreen,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  his_type: null,
  his_voice: null,
  show_love: null,
  personality: {
    dominant_submissive: 50,
    goofy_serious: 50,
    chaotic_thoughtful: 50,
    curious_certain: 50,
  },
  how_often_reach_out: null,
  flirting_style: null,
  hobbies_interests: null,
  role_in_relationship: null,
  name: '',
  email: '',
};

// Category constants - not used, it calculates in getCategoryByHisType function
export const HARDCODED_CATEGORIES = [];
